// Get Required Documents Use Case

import RequiredDocumentsRepository from "../../repositories/RequiredDocumentsRepository";
import { RequiredDocumentsResponse } from "../../entities/RequiredDocuments";

export default class GetRequiredDocumentsUseCase {
  constructor(private readonly repository: RequiredDocumentsRepository) {}

  /**
   * Executes the use case to get required documents for a customer
   * @param businessKey - Customer business key
   * @returns Promise resolving to required documents response
   */
  async execute(businessKey: string): Promise<RequiredDocumentsResponse> {
    if (!businessKey || businessKey.trim() === "") {
      return {
        success: false,
        message: "Business key is required",
        data: [],
      };
    }

    try {
      return await this.repository.getRequiredDocuments(businessKey);
    } catch (error) {
      console.error("GetRequiredDocumentsUseCase: Error", error);
      return {
        success: false,
        message:
          error instanceof Error
            ? error.message
            : "Failed to fetch required documents",
        data: [],
      };
    }
  }
}

